import script from "./StructuredDataCustom.vue?vue&type=script&lang=js"
export * from "./StructuredDataCustom.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__